<template>
  <div style="position: relative; display: inline-block; width: 100%">
    <div class="d-flex justify-space-between">
      <div class="d-flex align-end">
        <label v-if="label" class="input-label" :style="{ paddingLeft: Object.keys($attrs).includes('prepend-icon') ? '42px' : '0px' }">
          {{ label }} <small v-if="showRequired" class="mt-6 error--text">*</small>
        </label>
      </div>
      <v-btn class="included" color="primary" icon="mdi-auto-fix" @click="keepSelectedTextHighlighten">
        <v-icon></v-icon>
        <v-menu v-model="menu" activator="parent">
          <v-list class="mt-1">
            <v-list-item @click="improveSeletedText" :loading="processing" small icon title="Improve Selection" />
            <v-list-item @click="completeSentece" small icon title="Complete" />
            <v-list-item @click="generate" small icon title="Generate" />
          </v-list>
        </v-menu>
      </v-btn>
    </div>
    <v-textarea
      v-click-outside="{ handler: () => {}, include }"
      :disabled="processing"
      :loading="processing"
      :id="id"
      v-bind="$attrs"
      :model-value="modelValue"
      @update:modelValue="valueChanged"
      maxlength="5000"
    />
    <v-dialog v-model="dialog" max-width="800">
      <v-card class="scrollable-content">
        <v-form ref="frmMain" lazy-validation>
          <v-card-title> Answer the Following Questions </v-card-title>
          <v-card-text>
            <div v-for="(option, index) in options" :key="index">
              <span class="f-body-1">{{ (option as any).title }}</span>
              <v-radio-group v-model="(option as any).selected" :key="index" :rules="[validations.required]" row class="mt-2">
                <v-radio v-for="(choice, i) in (option as any).choices" :key="i" :label="choice" :value="choice" color="red"></v-radio>
              </v-radio-group>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="secondary_btn" @click="dialog = false">Cancel</v-btn>
            <v-btn class="primary_btn" @click="saveSelectedAnswers">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { OpenAIApi } from "../../services/openApi/api";
import store from "@/store";
import validations from "../../utils/validations";

export default defineComponent({
  data() {
    return {
      dialog: false,
      validations,
      menu: false,
      processing: false,
    };
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
    showRequired: {
      type: Boolean,
      required: false,
    },
    options: {
      type: Array,
      required: false,
      default: null,
    },
    computedOptions: {
      type: Array,
      required: false,
      default: null,
    },
  },
  methods: {
    keepSelectedTextHighlighten() {
      document.getElementById(this.id)?.focus();
    },
    include() {
      return [document.querySelector(".included")];
    },
    valueChanged(value: any) {
      this.$emit("update:modelValue", value);
    },
    toggleMenu() {
      this.menu = !this.menu;
    },
    saveSelection() {
      this.dialog = false;
      var selected = Array.prototype.map
        .call(this.options, function (item) {
          return item.selected;
        })
        .join(",");
    },
    async saveSelectedAnswers() {
      const isValid = (await (this.$refs.frmMain as any).validate()).valid;
      if (isValid) {
        this.dialog = false;
        var selected = Array.prototype.map
          .call(this.options, function (item) {
            return item.selected;
          })
          .join(",");
        this.fillTextBox(selected);
      }
    },
    generate() {
      if (this.computedOptions) {
        this.dialog = false;
        var selected = this.computedOptions.map((item) => item).join(",");
        this.fillTextBox(selected);
      } else if (!this.dialog) {
        this.dialog = true;
      }
    },
    async improveSeletedText() {
      this.processing = true;
      let textarea = document.getElementById(this.id) as HTMLTextAreaElement | null;
      if (textarea) {
        let start = textarea.selectionStart;
        let end = textarea.selectionEnd;
        if (start == end) store.dispatch("showErrorMessage", "Please select the sentence you would like to have improved.");
        else if (end - start < 15) store.dispatch("showErrorMessage", "Please write at least 15 characters.");
        else {
          let improved = await new OpenAIApi().suggestModificationOnWrittenText(textarea.value.substring(start, end));
          textarea.value = textarea.value.substring(0, start) + improved.data + textarea.value.substring(end);
          this.valueChanged(textarea.value);
        }
      }
      this.processing = false;
    },
    async completeSentece() {
      this.processing = true;
      let textarea = document.getElementById(this.id) as HTMLTextAreaElement | null;
      if (textarea) {
        if (textarea.value.length < 20) store.dispatch("showErrorMessage", "Please write at least one complete sentence.");
        else {
          let continuation = await new OpenAIApi().contentCompletionBasedOnWrittenText(textarea.value);
          textarea.value = textarea.value + " " + continuation.data;
          this.valueChanged(textarea.value);
        }
      }
      this.processing = false;
    },
    async fillTextBox(selected: any) {
      this.processing = true;
      let textarea = document.getElementById(this.id) as HTMLTextAreaElement | null;
      if (textarea) {
        let response = await new OpenAIApi().generateContentBasedOnKeyWords(selected);
        textarea.value = response.data;
        this.valueChanged(textarea.value);
      }
      this.processing = false;
    },
  },
  computed: {
    attrs(): any {
      return delete this.$attrs["label"];
    },
  },
});
</script>
<style>
.scrollable-content {
  max-height: 800px; /* Adjust this value as needed */
  overflow-y: auto;
}

.icon {
  width: 30px;
}
</style>
